<template>
  <div class="trainings-answering-page mt-4">
    <app-page-header title="Treinamentos"></app-page-header>

    <div v-if="!isLoading" class="container">
      <div class="row">
        <div class="col-12">
          <div class="training-info">
            <img :src="training.image" alt="Imagem Treinamento" />
            <div class="text">
              <h1>{{ training.title }}</h1>
              <p>{{ training.description }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p class="questions-counter">
            Pergunta {{ current + 1 }}/{{ training.training_questions.length }}
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div>
            <training-question-card
              :question="currentQuestion"
              v-model="answers[currentQuestion.id]"
            ></training-question-card>
            <div class="buttons">
              <button
                v-if="hasPrevious"
                @click="current = current - 1"
                v-app-button
              >
                Anterior
              </button>
              <button
                @click="current = current + 1"
                v-if="hasNext"
                :disabled="!hasAnsweredCurrent"
                v-app-button.secondary
              >
                Próximo
              </button>
              <button
                v-if="isLast"
                @click="onClickFinish()"
                :disabled="!hasAnsweredCurrent || isSaving"
                v-app-button.secondary
              >
                Finalizar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TrainingService from '@/services/training.service';
import TrainingQuestionCard from '@/components/Training/TrainingQuestionCard.vue';
import TrainingResponseModal from '@/components/Modal/TrainingResponseModal.vue';
import { SUM_POINTS } from '@/store/actions/auth';

export default {
  name: 'trainings-answering-page',
  components: {
    TrainingQuestionCard,
  },
  data: () => {
    return {
      isLoading: true,
      isSaving: false,
      training: {},
      current: 0,
      answers: {},
    };
  },
  computed: {
    currentQuestion() {
      return this.training.training_questions[this.current];
    },
    hasPrevious() {
      return !!this.training.training_questions[this.current - 1];
    },
    hasNext() {
      return !!this.training.training_questions[this.current + 1];
    },
    isLast() {
      return this.current == this.training.training_questions.length - 1;
    },
    hasAnsweredCurrent() {
      return !!this.answers[this.currentQuestion.id];
    },
  },
  methods: {
    onClickFinish() {
      this.$buefy.dialog.confirm({
        message:
          'Deseja salvar suas respostas? Você poderá tentar outras vezes caso não acerte tudo agora.',
        cancelText: 'Cancelar',
        confirmText: 'Sim, salvar',
        type: 'is-primary',
        onConfirm: () => this.finish(),
      });
    },
    finish() {
      this.isSaving = false;

      TrainingService.answer(this.training.id, this.answers)
        .then(({ data }) => {
          const { success, points } = data;

          success && this.$store.dispatch(SUM_POINTS, points);

          this.presentResultModal(data);
          this.$router.go(-1);
        })
        .catch(({ response }) => {
          const { status } = response;
          const message =
            status === 429
              ? 'Muitas tentativas realizadas. Tente novamente em alguns minutos.'
              : 'Erro ao tentar registrar respostas.';

          this.isSaving = false;
          this.toastify(message, 'error');
        });
    },
    onAnswer(questionId, answer) {
      this.$set(this.answers, questionId, answer);
    },
    loadTraining(id) {
      TrainingService.getId(id)
        .then(({ data: training }) => (this.training = training))
        .finally(() => (this.isLoading = false));
    },
    presentResultModal(response) {
      this.$buefy.modal.open({
        parent: this.$root,
        component: TrainingResponseModal,
        hasModalCard: true,
        trapFocus: true,
        props: {
          ...response,
          total: this.training.training_questions.length,
        },
      });
    },
  },
  beforeMount() {
    const id = this.$route.params.id;
    id && this.loadTraining(id);
  },
};
</script>

<style lang="scss" scoped>
.questions-counter {
  color: var(--color-secondary);
  font-weight: 500;
  font-size: 1.1em;
  text-align: right;
}

.training-question-card {
  background: #e5e5e5;
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 8px;
}

.buttons {
  button:first-child {
    margin-right: 8px;
  }
}

.training-info {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 16px;

  img {
    flex: 0 25%;
    width: 100%;
    object-fit: cover;
  }

  > div {
    flex: 0 75%;
    padding: 8px 16px;

    h1 {
      color: var(--color-primary);
      font-size: 2em;
      font-weight: bold;
      margin-bottom: 16px;
    }

    p {
      color: var(--text-color-light);
    }
  }
}
</style>
